import { Jcktk } from '../_entity_jck';
import { CR, EntityType, jkAlert, jkLib } from 'jk-service';
import { JcktkServicePkg } from './jcktkPkg.service';

/*
@Injectable({
  providedIn: 'root'
})*/


export class JcktkService extends JcktkServicePkg {
  constructor() {
    super();
    this.sqlSelect = 'SELECT TOP 20 JCKTK.*  FROM JCKTK';
    this.sqlWhereDefault = '/*WHERE*/ WHERE 1=1 AND TK003=' + this.quotedStr(this.userId) + ' AND TK005=' +
      jkLib.quotedStr('chat'); // ###

  }
  override async validateItem(item: any): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Jcktk): Promise<Jcktk> {
    await super.newRecord(newItem);
    newItem.TK001 = jkLib.nowDate() + "-" + jkLib.nowTime9();
    newItem.TK002 = jkLib.nowDate();
    newItem.TK003 = this.userId;
    return newItem;
  }
  //==== 以下為自訂函數 ====
  showTK001(e: string): string {
    return jkLib.timeStamp2Datetime(Number(e));
  }

  async onListDelete(item: Jcktk) {
    let keyObj = this.getKeyValues(item);
    //this.delete(keyObj);
    let ret = await this.doDelete(item, true);
    let n = this.itemList().findIndex((e: any) => item.TK001 === e.TK001);
    if (n < 0) return;
    this.itemList().splice(n, 1);
    //this.list.indexOf(item);
    jkAlert('已刪除');
  }
  onCopyList2Clipboard(item: Jcktk, programId: string) {
    let s = '';
    if (programId === 'GPTPI01') {
      s = '😐麻瓜提問: (tokens:' + item.TK008 + ')' + this.showTK001(item.TK001) + CR + item.TK006 + CR + CR +
        '🤖 回答:(tokens:' + item.TK009 + ')' + CR + item.TK007;
    }
    if (programId === 'GPTPI02') {
      s = '😐麻瓜提問: (tokens:' + item.TK008 + ')' + this.showTK001(item.TK001) + CR + item.TK006 + CR +
        '🤖 回答:(tokens:' + item.TK009 + ')' + CR + item.TK007;

    }
    if (programId === 'GPTPI03') {
      let urls = this.convertUrlList(item.TK007).join(CR);
      s = '😐麻瓜提問: ' + this.showTK001(item.TK001) + CR + item.TK006 + CR +
        '🤖 圖片網址(儘快下載):' + CR + urls;
    }
    if (s === '') {
      jkAlert('程式代號有誤' + programId);
      return;
    }
    jkLib.copy2Clipboard(s);
    jkAlert(programId + '已複製到剪貼簿');

  }
  convertUrlList(listString: string): string[] {
    let result: string[] = [];
    try {
      let list = JSON.parse(listString);
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let url = item.url;
        result.push(url);
      };

    } catch (error: any) {
      return result;
    }
    return result;
  };


}
